/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IconButton, MdiIcon, Typography, Grid, Checkbox, Box, Tooltip, Chip } from '@mic3/platform-ui';
import DotMenu from 'app/components/molecules/DotMenu/DotMenu';
import moment from 'moment';
import worker from 'app/utils/worker/worker';
import { muiTheme } from 'app/themes/materialUi';
import Loader from 'app/components/atoms/Loader/Loader';
import Button from 'app/components/atoms/Designer/Button';
import styled from 'styled-components';

import { loadEntitiesFullListComponent, loadEntitiesBaseListComponent } from 'store/actions/entities/entitiesActions';
import { executeScript, loadScript, executeScriptForViewer } from 'store/actions/designer/designerScriptActions';
import { getStr, capitalizeFirstLetter, isObject, isDefined } from 'app/utils/utils';
import { isString } from 'app/utils/string/string-utils';
import { formatDate, fromNow, isIsoDate, parseDurationText } from 'app/utils/date/date';
import { buildDateTimaRangeStringValue } from 'app/utils/designer/form/fieldUtils';
import { get, pick } from 'app/utils/lo/lo';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import { prepareFunction } from 'app/utils/designer/form/formUtils';
import { entitiesDefaultFilterDefinitions } from 'app/utils/entity/entityUtils';
import { buildCustomDefinitions, getSelectedPrimaryClass } from 'app/utils/classification/classificationUtils';
import { TASKLAYERS, PROCESSLAYERS } from 'app/utils/maps/layer/layerUtils';
import { tasksFilterDefinitions } from 'app/components/organisms/TasksView/tasksFilterDefinitions';
import { formatOptionsForTask } from 'app/utils/formatter/graphql-formatter';
import processFilterDefinitions from 'app/containers/Abox/ProcessesList/ProcessFilters';
import { setDocumentTitle, showToastr } from 'store/actions/app/appActions';
import { modulesAndPageTitles } from 'app/config/typesConfig';
import { normalizeFilterOptions } from 'app/utils/formatter/graphql-formatter';
import Filters from 'app/components/organisms/Filters/Filters';
import VirtualListManaged from 'app/components/molecules/VirtualList/VirtualListManaged';
import EntityListAttributeModalItem from './EntityListAttributeModalItem';
import EntityListAttributeBJModal from './EntityListAttributeBJModal';
import { runScript } from 'store/actions/abox/backgroundJobActions';
import FiltersInternalSidebar from 'app/components/organisms/Filters/FiltersInternalSidebar';
import ModalFormGenearator from 'app/components/organisms/ModalFormGenearator/ModalFormGenearator';

const StyledTypography = styled(Typography)`
    font-size: 12px !important;
    font-weight: 400 !important ;
    line-height: 16px !important;
    letter-spacing: 0.4px !important;
`;
const ChipStyled = styled(Chip)`
    margin: 1px;
    height: 24px;
    color: ${({ theme }) => theme.material.palette.text.secondary};
`;

const FiltersWrapper = styled.div`
    display: flex;
    width: 99% !important;
    height: calc(100vh - 104px) !important;

    & div.global-template-sidebar {
    padding-top: ${({ isMobile }) => isMobile && '1px !important'};
    }
`;

const LeftToolbarStyled = styled(Grid)`
    margin-top: -48px;
`;


const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 12px 0;

    & button {
        display: flex;
        width: 100%;
        max-width: 1000px;
        height: 36px;
        margin-right: 18px;
        margin-left: 8px;
        & i:before {
            font-size: 18px !important;
        }
    }
`;


const LeftToolbarHeaderStyled = styled(Typography)`
    margin-top: 8px !important;
`;

const Wrapper = styled.div`
    position: fixed;
    top: ${({ isMobile, isSidebar }) => isMobile || isSidebar ? '55px' : '0px'};
    left: ${({isSidebar, isMobile }) => isSidebar && !isMobile? '65px' : '0px'};
    right: 0px;
    bottom: 0px;
    z-index: 99;
    background: ${({ theme }) => theme.base.background};
`;

class EntityListAttributeModal extends PureComponent {
    static propTypes = {
        loadEntitiesFullListComponent: PropTypes.func.isRequired,
        records: PropTypes.array,
        isLoading: PropTypes.bool,
        totalRecords: PropTypes.number,
    };

    constructor(props) {
        super(props);
        this.state = {
            view: props.value?.length ? 'selected' : 'all',
            selectedIds: [],
            selectedItemsMap: {},
            isLoadingAll: false,
            value: props.value || [],
            addNewIds: [],
            showActionNotification: false,
            records: [],
            filterSidebarOptions: { isOpen: false },
            visibilityCache: new Map(),
            scriptForm: null,
        };
    }

    searchBar = ['name', 'id'];
    listRef = React.createRef();
    filtersRef = React.createRef();
    defaultOrder = [{ field: 'modifiedDate', direction: 'desc nulls last' }];
    defaultFilters = {};
    firstLoading = true;

    componentWillUnmount() {
        this.refreshView();
    }

    componentDidMount() {
        const { leftPanelRecords, match, setDocumentTitle } = this.props;
        const type = getStr(match, 'params.type');
        if (type) {
            const entityName = this.setHeaderTitle(type, leftPanelRecords);
            setDocumentTitle(`Entities - ` + entityName);
        } else {
            setDocumentTitle(modulesAndPageTitles.entities.main);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { leftPanelRecords, setDocumentTitle, value } = this.props;
        const pType = getStr(prevProps, 'match.params.type');
        const type = getStr(this.props, 'match.params.type');
        if (type && type !== pType) {
            const entityName = this.setHeaderTitle(type, leftPanelRecords);
            if (entityName) {
                setDocumentTitle(`Entities - ` + entityName);
            }
        }

        if (prevProps.value !== value) {
            this.setState({ value: value || [] });
        }

        // Handle filtering: check if selected items still exist in new filtered results
        if (prevState.totalRecords !== this.state.totalRecords && this.state.selectedIds.length > 0) {
            const wasAllSelected = prevState.selectedIds.length === prevState.totalRecords;
            this.updateSelectionAfterFilter(wasAllSelected);
        }
    }

    @bind
    async updateSelectionAfterFilter(wasAllSelected) {
        const filterBy = get(this.listRef, 'current.props.filterBy', []);
        const excludeBy = get(this.listRef, 'current.props.excludeBy', []);
        const orderBy = get(this.listRef, 'current.props.orderBy', []);

        try {
            const fullResponse = await this.loadData({ filterBy, excludeBy, orderBy }, 'base');
            const allNewIds = (fullResponse?.records || []).map(item => item.id);
            const allNewIdsSet = new Set(allNewIds);
            const { selectedIds, selectedItemsMap } = this.state;

            // Check if all new filtered items were previously selected (only matters when wasAllSelected)
            const shouldSelectAll = wasAllSelected && allNewIds.every(id => selectedIds.includes(id)) && allNewIds.length > 0;

            // Determine final selected IDs
            const finalSelectedIds = shouldSelectAll ? allNewIds : selectedIds.filter(id => allNewIdsSet.has(id));

            // Build filtered items map
            const filteredItemsMap = finalSelectedIds.reduce((map, id) => {
                if (selectedItemsMap[id]) {
                    map[id] = selectedItemsMap[id];
                }
                return map;
            }, {});

            this.setState({
                selectedIds: finalSelectedIds,
                selectedItemsMap: filteredItemsMap
            }, this.forceUpdateGrid);
        } catch (error) {
            console.error('Failed to update selection after filter:', error);
        }
    }

    @bind
    convertDateTimeRangeToDate({ unit, range, amount, relative }) {
        if (!relative || !amount || !unit || !range) return null;

        const currentDate = moment();
        const calculatedDate = moment(currentDate)[range](amount, unit);

        const minDate = moment('1970-01-01', 'YYYY-MM-DD');
        const maxDate = moment('4821-12-26', 'YYYY-MM-DD');

        if (!calculatedDate.isValid() || calculatedDate.isBefore(minDate) || calculatedDate.isAfter(maxDate)) {
            console.warn('Date is out of valid range:', calculatedDate.toString());
            return null;
        }

        const dataFormat = 'DD MMM YYYY, HH:mm';

        const startDate = currentDate.isBefore(calculatedDate) ? currentDate : calculatedDate;
        const endDate = currentDate.isBefore(calculatedDate) ? calculatedDate : currentDate;

        const startStr = startDate.format(dataFormat);
        const endStr = endDate.format(dataFormat);

        return `${startStr} - ${endStr}`;
    }

    @bind
    async refreshView() {
        const { resetView } = this.listRef.current || {};
        resetView && (await resetView());
    }

    @bind
    getUserDefinedFilters(type) {
        const selectedClass = getSelectedPrimaryClass(type, this.props.primaryClasses);
        return buildCustomDefinitions(selectedClass);
    }

    @bind
    @memoize()
    setFilterDefinitions(type) {
        let filters = [];
        if (TASKLAYERS.includes(type)) {
            filters = [...tasksFilterDefinitions];
        } else if (PROCESSLAYERS.includes(type)) {
            filters = [...processFilterDefinitions];
        } else {
            filters = entitiesDefaultFilterDefinitions([type]);
            filters.splice(3, 0, {
                field: 'relations.relatedEntity.id',
                type: 'relatedEntities',
                properties: {
                    label: 'Related Entities',
                    name: 'relatedEntities',
                },
                condition: 'in',
                sort: false,
            });

            const customFilters = this.getUserDefinedFilters(type);
            filters.push(...customFilters);
        }

        if (['system_process'].includes(type)) {
            filters.forEach((filter) => {
                const { name } = filter?.properties || {};
                if (name === 'status') {
                    if (type === 'system_process') {
                        this.defaultFilters = { [name]: null };
                        filter.properties.disabled = false;
                    } else {
                        this.defaultFilters = { [name]: type === 'openprocess' ? 'is null' : 'is not null' };
                        filter.properties.disabled = true;
                    }
                }
            });
        }
        if (['system_task'].includes(type)) {
            filters.forEach((filter) => {
                const { name } = filter?.properties || {};
                if (name === 'statusType') {
                    if (type === 'system_task') {
                        this.defaultFilters = { [name]: null };
                        filter.properties.disabled = false;
                    } else {
                        this.defaultFilters = { [name]: type };
                        filter.properties.disabled = true;
                    }
                }
            });
        }

        return filters;
    }

    @bind
    async loadData({ filterBy, excludeBy = [], ...restOptions }, loadType) {
        const { loadEntitiesFullListComponent, loadEntitiesBaseListComponent, type, filterEntitiesBy, userProfile } = this.props;
        const { value, addNewIds } = this.state;
        const selectedIds = value.map(({ id }) => id).filter(Boolean) || [];
        const addNewFilter = addNewIds.length ? [{ field: 'id', op: 'in', value: addNewIds }] : [];
        const valueFilter = !addNewIds.length && selectedIds.length ? [{ field: 'id', op: 'in', value: selectedIds }] : [];
        let updatedExcludeBy = excludeBy;
        let updatedFilterBy = filterBy;

        if (type === 'system_task') {
            const { filterBy: formatedFilterBy, excludeBy: formatedExcludeBy } = formatOptionsForTask({ filterBy, excludeBy }, userProfile);
            updatedFilterBy = formatedFilterBy;
            updatedExcludeBy = formatedExcludeBy;
        }

        const filters = [...updatedFilterBy, ...filterEntitiesBy, ...valueFilter].filter(Boolean);

        const exclude = [...updatedExcludeBy, ...addNewFilter].filter(Boolean);

        let result = null;
        const normalizeFilters = filters.map((item) => {
            if (typeof item.value === 'number' && !isNaN(item.value)) {
                return { ...item, value: String(item.value) };
            }
            return item;
        });
        if (type) {
            if (loadType === 'base') {
                result = await loadEntitiesBaseListComponent({
                    options: normalizeFilterOptions({
                        ...restOptions,
                        filterBy: normalizeFilters,
                        excludeBy: exclude,
                        startIndex: 0,
                        stopIndex: this.state.totalRecords,
                    }),
                    type,
                });
            } else {
                result = await loadEntitiesFullListComponent({
                    options: normalizeFilterOptions({
                        ...restOptions,
                        filterBy: normalizeFilters,
                        excludeBy: exclude,
                    }),
                    type,
                });
                this.firstLoading = false;

                this.setState({
                    isLoadingAll: false,
                    records: result.records,
                    totalRecords: result.count,
                });
            }
        }

        return result;
    }

    @bind
    @memoize()
    setHeaderTitle(type, leftPanelRecords) {
        const { name } = leftPanelRecords.find((cls) => cls.uri === type) || {};
        return name || 'Entities';
    }

    @bind
    forceUpdateGrid() {
        this.listRef.current && this.listRef.current.forceUpdate();
    }

    @bind
    handleSelect(id, item) {
        this.setState((prevState) => {
            const { selectedIds, selectedItemsMap } = prevState;
            const isAlreadySelected = selectedIds.includes(id);

            const updatedSelectedIds = isAlreadySelected ? selectedIds.filter((i) => i !== id) : [...selectedIds, id];

            const updatedItemsMap = { ...selectedItemsMap };
            if (isAlreadySelected) {
                delete updatedItemsMap[id];
            } else {
                updatedItemsMap[id] = item;
            }

            return {
                selectedIds: updatedSelectedIds,
                selectedItemsMap: updatedItemsMap,
            };
        }, this.forceUpdateGrid);
    }

    @bind
    async handleSelectAllItems() {
        const { totalRecords, selectedIds } = this.state;
        if (selectedIds.length === totalRecords) {
            this.setState(
                {
                    selectedIds: [],
                    selectedItemsMap: {},
                },
                this.forceUpdateGrid
            );
            return;
        }

        this.setState({ isLoadingAll: true });
        const { records } = this.state;
        try {
            const filterBy = get(this.listRef, 'current.props.filterBy', []);
            const excludeBy = get(this.listRef, 'current.props.excludeBy', []);
            const orderBy = get(this.listRef, 'current.props.orderBy', []);

            const fullResponse = await this.loadData({ filterBy, excludeBy, orderBy }, 'base');
            const allItems = fullResponse?.records || [];

            const allIds = allItems.map((item) => item.id);

            const recordMap = records.reduce((map, item) => {
                map[item.id] = item;
                return map;
            }, {});

            const selectedItemsMap = allItems.reduce((map, item) => {
                const match = recordMap[item.id];

                map[item.id] = {
                    ...item,
                    ...(match && {
                        name: match.name,
                        type: match.type,
                        image: match.image,
                    }),
                };

                return map;
            }, {});
            this.firstLoading = false;

            this.setState({
                selectedIds: allIds,
                selectedItemsMap,
                isLoadingAll: false,
            });
        } catch (error) {
            console.error('Failed to select all items:', error);
        } finally {
            this.forceUpdateGrid();
            this.setState({ isLoadingAll: false });
        }
    }

    @bind
    renderChildren(data) {
        const { addNewIds, value } = this.state;
        const { actions, isDynamicList, isMobile } = this.props;

        if ((!addNewIds.length && value.length) || isDynamicList) {
            if (!actions?.length) return [];

            const dotMenuItems = actions.map((action) => ({
                name: action.label,
                icon: action.icon?.value,
                iconType: action.icon?.type,
                onItemClick: () => this.handleRunAction(action, data),
            }));

            if (isMobile) {
                return [
                    <DotMenu
                        key="dotmenu"
                        items={dotMenuItems}
                    />,
                ];
            }

            const actionIcons = actions.slice(0, 3).map((action, i) => {
                const { icon } = action;
                return (
                    <Tooltip arrow title={action.label} key={i}>
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                this.handleRunAction(action, data);
                            }}
                        >
                            <MdiIcon name={icon.value} type={icon.type} size="18px" />
                        </IconButton>
                    </Tooltip>
                );
            });

            const extraDotMenu =
                actions.length > 3 ? (
                    <DotMenu
                        key="dotmenu"
                        items={dotMenuItems.slice(3)}
                    />
                ) : null;

            return extraDotMenu ? [...actionIcons, extraDotMenu] : actionIcons;
        }

        return [];
    }

    @bind
    hasExactName(value, name) {
        const lastPart = value.split('.').pop();
        return lastPart === name;
    }

    @bind
    getAttributeSetings(attr) {
        const { fieldType, value } = attr;
        const { primaryClasses = [], type } = this.props;
        const primaryClass = primaryClasses.filter((item) => item.uri === type);
        const children = get(primaryClass, '[0].formDefinition.fields', [])
            .map((item) => item.children)
            .flat();
        const fullAttributes = children.filter((item) => item.type === fieldType && this.hasExactName(value, item.properties.name));
        return fullAttributes;
    }

    @bind
    isVisibleColor(color) {
        if (!isString(color)) return muiTheme.colors.text.primary;
        const normaliedColor = color.toLowerCase();
        const priorityColors = muiTheme.colors.priorityTaskColors;
        switch (normaliedColor) {
            case 'highest':
                return get(priorityColors, `1.0`);
            case 'high':
                return get(priorityColors, `2.0`);
            case 'medium':
                return get(priorityColors, `3.0`);
            case 'low':
                return get(priorityColors, `4.0`);
            case 'lowest':
                return get(priorityColors, `5.0`);
            default:
                muiTheme.colors.text.primary;
        }
    }

    @bind
    resolveAttribute(attr, data) {
        const value = get(data, attr.value);

        if (attr.fieldType === 'chip') {
            return <ChipStyled variant="outlined" label={attr.label} size="small" />;
        }
        if (attr.fieldType === 'date' || attr.fieldType === 'dateTime') {
            const dateSettings = this.getAttributeSetings(attr);
            let formatType = get(dateSettings, '[0].properties.format');

            if (!formatType && attr.fieldType === 'date') {
                formatType = 'DD MMM YYYY';
            }
            return String(formatDate(value, formatType));
        }

        if (typeof value === 'boolean') {
            return String(value);
        }

        if (Array.isArray(value)) {
            if (value.every((v) => isIsoDate(v))) {
                return buildDateTimaRangeStringValue(value);
            }
            if (value.every((v) => typeof v === 'string' || typeof v === 'number')) {
                return value.join(', ');
            }
            const field = attr.fieldType === 'relationDefinitionTypeahead' ? 'description' : 'name';
            return value.map((v) => (isObject(v) ? get(v, field) : String(v)));
        }

        if (isObject(value)) {
            switch (attr.fieldType) {
                case 'dateTimeRange':
                    return value;
                case 'geotagAddress':
                    return String(value.address) || `${value?.latitude}, ${value?.longitude}`;
                case 'geotagButton':
                    return `${value.lat}, ${value.lng}`;
                case 'geotagPosition':
                case 'geotagLocation':
                    const { latitude, longitude, address = {} } = value || {};

                    const locationFields = [
                        latitude,
                        longitude,
                        address?.city,
                        address?.code,
                        address?.country,
                        address?.line1,
                        address?.line2,
                        address?.province,
                    ].filter(Boolean);

                    return locationFields.join(', ');
                case 'iconSelect':
                    return <MdiIcon type={value.type} size={14} name={value.value} />;
                case 'duration':
                    return parseDurationText(value?.value, value?.isDuration);
                case 'hyperlink':
                    return (
                        <a href={value.link} target="_blank" rel="noreferrer noopener">
                            {value.text}
                        </a>
                    );
                case 'json':
                    return JSON.stringify(value);
                case 'relationDefinitionTypeahead':
                    return get(value, 'description');
                default:
                    return get(value, 'name');
            }
        }

        return value;
    }

    @bind
    @memoize()
    async isVisible(data) {
        const { context, entityAttributes } = this.props;
        const { visibilityCache } = this.state;

        const cacheKey = data.id;
        if (visibilityCache.has(cacheKey)) {
            return visibilityCache.get(cacheKey);
        }

        const results = await Promise.all(
            entityAttributes.map(async (attr) => {
                if (attr.isVisible === undefined) return { ...attr, isVisible: true };
                const actions = await worker(await prepareFunction(attr.isVisible), data, context);
                return {
                    ...attr,
                    isVisible: actions,
                };
            })
        );

        this.setState((prevState) => ({
            visibilityCache: new Map(prevState.visibilityCache.set(cacheKey, results)),
        }));

        return results;
    }

    @bind
    renderAttribute(data) {
        const { entityAttributes = [], relatedEntityDefinition } = this.props;
        const { visibilityCache } = this.state;

        if (!data) return null;

        const visibleAttributes = visibilityCache.get(data.id) || entityAttributes;
        const normalizedEntityAttributes = visibleAttributes
            .filter((attr) => attr.isVisible !== false)
            .map((attr) => {
                if (attr.value.includes(data?.type)) {
                    const resolved = this.resolveAttribute(attr, data);
                    if (Array.isArray(resolved)) {
                        return {
                            fieldType: attr.fieldType,
                            label: attr.label,
                            value: resolved.join(', '),
                            isVisible: attr.isVisible,
                        };
                    }
                    return { label: attr.label, value: resolved, fieldType: attr.fieldType, isVisible: attr.isVisible };
                }

                if (attr.value.includes('attributes')) {
                    const normalizeRelations = data.relations.filter((item) => item.relation?.relationDefinition?.id === relatedEntityDefinition?.id);
                    return normalizeRelations?.map((relation) => {
                        if (attr.value.includes('relatedEntity.name')) {
                            return {
                                fieldType: attr.fieldType,
                                label: attr.label,
                                value: get(relation, 'relatedEntity.name'),
                                isVisible: attr.isVisible,
                            };
                        }
                        const resolved = this.resolveAttribute(attr, relation.relation);
                        if (Array.isArray(resolved)) {
                            return {
                                fieldType: attr.fieldType,
                                label: attr.label,
                                value: resolved.join(', '),
                                isVisible: attr.isVisible,
                            };
                        }
                        return {
                            fieldType: attr.fieldType,
                            label: attr.label,
                            value: resolved,
                            isVisible: attr.isVisible,
                        };
                    });
                }

                switch (attr.value) {
                    case 'modifiedBy.username':
                        return {
                            label: attr.label,
                            value: get(data, 'modifiedBy.name'),
                            isVisible: attr.isVisible,
                        };
                    case 'createdBy.username':
                        return {
                            label: attr.label,
                            value: get(data, 'createdBy.name'),
                            isVisible: attr.isVisible,
                        };
                    case 'active':
                        return {
                            label: attr.label,
                            value: String(get(data, 'active')),
                            isVisible: attr.isVisible,
                        };
                    default:
                        return {
                            fieldType: attr.fieldType,
                            label: attr.label,
                            value: isDefined(get(data, attr.value)) ? String(get(data, attr.value)) : '',
                            isVisible: attr.isVisible,
                        };
                }
            })
            .flat(Infinity);

        if (!visibilityCache.has(data.id)) {
            this.isVisible(data).catch(console.error);
        }

        return (
            <Grid container spacing={2}>
                {normalizedEntityAttributes.map((item, i) => (
                    <Grid item xs={12} sm={4} key={i}>
                        <Box display="flex" alignItems="center">
                            <StyledTypography style={{ color: muiTheme.colors.text.secondary, marginRight: '4px' }}>{item?.label}:</StyledTypography>
                            <Tooltip
                                title={
                                    item?.fieldType === 'dateTimeRange' && isObject(item?.value)
                                        ? this.convertDateTimeRangeToDate(item?.value)
                                        : isIsoDate(item?.value) && ['dateTimeRange', 'dateTime', 'date'].includes(item?.fieldType)
                                            ? formatDate(item?.value)
                                            : item?.value
                                }
                            >
                                <StyledTypography
                                    style={{
                                        maxWidth: '200px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        color: this.isVisibleColor(item.isVisible),
                                    }}
                                >
                                    {item?.fieldType === 'dateTimeRange' && isObject(item?.value)
                                        ? buildDateTimaRangeStringValue(item?.value)
                                        : isIsoDate(item?.value) && ['dateTimeRange', 'dateTime', 'date'].includes(item?.fieldType)
                                            ? fromNow(item?.value)
                                            : item?.value || ''}
                                </StyledTypography>
                            </Tooltip>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        );
    }

    @bind
    renderComponent(props) {
        const { selectedIds } = this.state;
        const { data } = props;
        const selected = selectedIds.includes(data.id);
        return (
            <EntityListAttributeModalItem
                {...props}
                selected={selected}
                onClick={() => this.handleSelect(data.id, data)}
                key={props.index}
                children={this.renderChildren(data)}
                attributes={this.renderAttribute(data)}
            />
        );
    }

    @bind
    handleAdd() {
        const { onApply, onClose, name, value = [], onMouseDown } = this.props;
        const selectedItems = Object.values(this.state.selectedItemsMap);

        onApply && onApply({ target: { value: [...value, ...selectedItems].map((v) => pick(v, ['id', 'name', 'image', 'type'])), name } });
        this.resetState();
        onMouseDown && onMouseDown();
        onClose && onClose();
    }
    @bind
    handelClose() {
        const { onClose } = this.props;
        this.resetState();
        onClose && onClose();
    }

    @bind
    async addNewItem() {
        const { value } = this.state;
        const { onMouseDown } = this.props;
        const selectedIds = value.map(({ id }) => id).filter(Boolean) || [];

        onMouseDown && onMouseDown();
        this.setState(
            {
                addNewIds: selectedIds,
                isLoadingAll: true,
                view: 'all',
                records: [],
                totalRecords: 0,
            },
            this.refreshView
        );
    }
    @bind
    resetState() {
        this.setState({
            selectedIds: [],
            selectedItemsMap: {},
            addNewIds: [],
            stopIndex: 0,
        });
    }

    @bind
    async runAction(input) {
        const { executeScript, showToastr, runScript, loadEntitiesShortList } = this.props;
        const { selected, entity, formData = {}, action } = input;
        const nextState = { scriptForm: null, scriptInput: null };
        if (selected.length <= 100) {
            const result = await executeScript(action.script.id, { selected, entity, formData });
            if (!(result instanceof Error)) {
                await showToastr({ detail: 'Action executed successfully', severity: 'success' });
            }
            this.filtersRef.current?.forceUpdate();
        } else {
            const result = await runScript({
                name: `Action "${action.label}"`,
                script: action.script.id,
                input: { selected, entity, formData },
            });
            if (!(result instanceof Error)) {
                nextState.showActionNotification = result?.id || null;
            }
        }
        loadEntitiesShortList();
        this.setState(nextState);
    }

    @bind
    async handleRunAction(action, datas) {
        const dataList = datas.id ? [datas] : Object.values(datas);
        const { loadScript, details } = this.props;
        const script = await loadScript(action.script.id);
        const formDefinition = get(script, 'formDefinition.primary.definition', null);

        const input = {
            selected: dataList.map((item) => {
                return {
                    id: item.id,
                    name: item.name,
                    type: item.type,
                };
            }),
            entity: {
                id: details?.id,
                name: details?.name,
                type: details?.type,
            },
        };

        if (isDefined(formDefinition)) {
            this.setState({ scriptInput: input, scriptForm: { formDefinition, title: action.label, action } });
        } else {
            this.runAction({
                ...input,
                action,
            });
        }
    }

    @bind
    handleCloseSciptModal() {
        this.setState({ scriptForm: null, scriptInput: null });
    }

    @bind
    handleFormScript(evnt) {
        const formData = evnt.target.value || {};
        const {
            scriptForm: { action },
            scriptInput,
        } = this.state;
        this.runAction({
            ...scriptInput,
            action,
            formData,
        });
    }

    @bind
    handleCloseActionNotification() {
        this.setState({ showActionNotification: null });
    }

    @bind
    removeItem() {
        const { onApply, onClose, name, value = [], onMouseDown } = this.props;
        const { selectedIds } = this.state;
        const filteredValues = value.filter((item) => !selectedIds.includes(item.id));

        onApply && onApply({ target: { value: [...filteredValues], name } });
        onMouseDown && onMouseDown();
        this.resetState();
        onClose && onClose();
    }

    @bind
    closeFilterSidebar() {
        this.setState({ filterSidebarOptions: { isOpen: false } });
    }
    @bind
    openFilterSidebar(filterBarOptions) {
        this.setState({ filterSidebarOptions: filterBarOptions });
    }

    @bind
    renderAddButton(defaultLoading) {
        const { value, addNewIds, selectedIds } = this.state;
        if (!addNewIds.length && value.length && !selectedIds.length) {
            return (
                <Tooltip arrow title="Click to add">
                    <ButtonWrapper>
                        <Button disabled={defaultLoading} onClick={this.addNewItem}>
                            <MdiIcon name="plus" /> ADD NEW
                        </Button>
                    </ButtonWrapper>
                </Tooltip>
            );
        }
        return null;
    }

    @bind
    renderRemoveButton() {
        const { value, selectedIds, addNewIds } = this.state;
        if (!addNewIds.length && value.length && selectedIds.length) {
            return (
                <Tooltip arrow title="Click to remove">
                    <ButtonWrapper>
                        <Button onClick={this.removeItem}>REMOVE</Button>
                    </ButtonWrapper>
                </Tooltip>
            );
        }
        return null;
    }

    render() {
        const { view, type, startIndex, isLoading, label, name, isMobile, isSidebar, primaryClasses, isDynamicList, details } = this.props;
        const {
            selectedIds,
            isLoadingAll,
            value,
            totalRecords,
            records,
            addNewIds,
            showActionNotification,
            selectedItemsMap,
            filterSidebarOptions,
            visibilityCache,
            scriptForm,
        } = this.state;
        const defaultLoading = this.firstLoading || isLoading || (isLoading && !startIndex);
        const isAllItemsSelected = totalRecords === selectedIds.length;
        const filterDefinitions = this.setFilterDefinitions(type);
        const primaryClass = primaryClasses.find((item) => item?.uri === type);
        return (
            <>
                <Wrapper key={view} isMobile={isMobile} isSidebar={isSidebar}>
                    {isLoadingAll && <Loader absolute backdrop />}
                    <FiltersWrapper isMobile={isMobile}>
                        <Filters
                            id={details?.id || name}
                            key={view}
                            ref={this.filtersRef}
                            filterDefinitions={filterDefinitions}
                            searchBar={this.searchBar}
                            defaultOrder={this.defaultOrder}
                            heightOffset={255}
                            disableLeftPanelFilters
                            defaultFilters={this.defaultFilters}
                            buildInternalFilterBar={this.openFilterSidebar}
                            leftToolbar={
                                <LeftToolbarStyled container>
                                    {!selectedIds.length ? (
                                        <>
                                            <IconButton onClick={this.handelClose}>
                                                <MdiIcon name={'close'} />
                                            </IconButton>
                                            <LeftToolbarHeaderStyled variant="h6">{label}</LeftToolbarHeaderStyled>
                                        </>
                                    ) : (
                                        <Box style={{ display: 'flex', alignItems: 'center', flexDirection: isMobile ? 'column' : 'row' }}>
                                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                <Checkbox
                                                    onClick={this.handleSelectAllItems}
                                                    value={selectedIds?.length || totalRecords}
                                                    style={{ marginRight: '8px' }}
                                                    CheckboxProps={{
                                                        checkedIcon:
                                                            !isAllItemsSelected && selectedIds?.length > 0
                                                                ? <MdiIcon name="checkbox-intermediate" />
                                                                : <MdiIcon name="checkbox-marked" />,
                                                    }}
                                                />
                                                <Typography variant="h6" style={{ fontSize: '16px', maxWidth: isMobile ? '150px' : 'none' }}>
                                                    {isAllItemsSelected
                                                        ? `Selected all ${totalRecords} ${totalRecords === 1 ? 'item' : 'items'}`
                                                        : `${selectedIds.length} selected`}

                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </LeftToolbarStyled>
                            }
                            rightToolbar={
                                <>
                                    {((selectedIds.length && !value.length) || (value.length && addNewIds.length && selectedIds.length)) && !isDynamicList ? (
                                        <>
                                            <Button variant="text" onClick={this.handelClose}>
                                                CANCEL
                                            </Button>
                                            <Button onClick={this.handleAdd}>ADD</Button>
                                        </>
                                    ) : null}

                                    {(!addNewIds.length && value.length && selectedIds.length) || (isDynamicList && selectedIds.length && totalRecords)
                                        ? this.renderChildren(selectedItemsMap)
                                        : null}
                                </>
                            }
                        >
                            {(filterBy, orderBy) => (
                                <>
                                    {this.renderAddButton(defaultLoading)}
                                    {this.renderRemoveButton()}

                                    <VirtualListManaged
                                        key={view}
                                        ref={this.listRef}
                                        visibilityCache={visibilityCache}
                                        renderComponent={this.renderComponent}
                                        loadData={this.loadData}
                                        itemSize={65}
                                        maxWidth="1024"
                                        itemCount={totalRecords || 0}
                                        isLoading={defaultLoading}
                                        filterBy={filterBy}
                                        orderBy={orderBy}
                                        list={records}
                                        startIndex={startIndex}
                                        title={
                                            !value.length || addNewIds.length
                                                ? `${totalRecords >= 1000 ? '999+' : totalRecords || 0} ${capitalizeFirstLetter(primaryClass?.name)}`
                                                : 0
                                        }
                                    />
                                </>
                            )}
                        </Filters>
                        <FiltersInternalSidebar closeSidebar={this.closeFilterSidebar} options={filterSidebarOptions} />
                    </FiltersWrapper>
                    {showActionNotification && <EntityListAttributeBJModal jobId={showActionNotification} onClose={this.handleCloseActionNotification} />}
                </Wrapper>
                {scriptForm && (
                    <ModalFormGenearator
                        components={scriptForm.formDefinition}
                        onChange={this.handleFormScript}
                        title={scriptForm.title}
                        isOpen
                        onClose={this.handleCloseSciptModal}
                        context={{ scriptInput: this.state.scriptInput }}
                    />
                )}
            </>
        );
    }
}

export default connect(
    (state) => ({
        isLoading: state.entities.entitiesList.isLoading,
        startIndex: state.entities.entitiesList.startIndex,
        userProfile: state.user.profile,
        primaryClasses: state.app.allPrimaryClasses.records,
        leftPanelRecords: state.app.allPrimaryClasses.records || [],
        isMobile: state.global.isMobile,
        scripts: state.designer.scripts,
    }),
    { runScript, loadEntitiesFullListComponent, setDocumentTitle, loadEntitiesBaseListComponent, executeScript, executeScriptForViewer, loadScript, showToastr }
)(EntityListAttributeModal);
